import type { TOC } from '@ember/component/template-only';
import { PrismIcon, PrismIconFlag } from '@mylighthouse/prism-ember';
import type { IconSize } from '@mylighthouse/prism-ember/types/components/prism/icon';
import { eq } from 'ember-truth-helpers';

interface GeneralCountryFlagSignature {
  Args: {
    countryCode: string;
    size?: IconSize;
  };
}

const GeneralCountryFlag = <template>
  {{! @glint-nocheck: not typesafe yet }}
  {{#if (eq @countryCode "multiple")}}
    <PrismIcon @name="events-global" @size={{if @size @size "small"}} />
  {{else}}
    <PrismIconFlag @code={{@countryCode}} @size={{if @size @size "small"}} />
  {{/if}}
</template> satisfies TOC<GeneralCountryFlagSignature>;

export default GeneralCountryFlag;
